/* Tippy configuration */

@use "../node_modules/tippy.js/dist/tippy.css";
@use "../node_modules/tippy.js/themes/light.css";
@use "../node_modules/tippy.js/themes/light-border.css";
@use "../node_modules/tippy.js/themes/material.css";
@use "../node_modules/tippy.js/themes/translucent.css";

/* Common variables configuration */

@import "styles/common-variables.scss";

/* Flagpack configuration */

$fp-4x3-path: './fonts/flags/4x3/';
$fp-1x1-path: './fonts/flags/1x1/';

@import "../node_modules/flagpack-dart-sass/src/flagpack.scss";

/* Intelogy configuration */

$autocomplete-color: $input-color;
$autocomplete-bg: $input-bg;
$autocomplete-border-width: $input-border-width;
$autocomplete-border-color: #767676;
$autocomplete-item-padding-x: $input-padding-x;
$autocomplete-item-selected-bg: #1e90ff;
$autocomplete-item-hover-bg: #e8e8e8;
$plhrable-color: $input-color;
$plhrable-placeholder-color: $input-placeholder-color;
$sort-indicator-color: $client-highlight;

@import 'framework/html_behaviors/af-autocomplete.scss';
@import 'framework/html_behaviors/af-plhrable.scss';
@import 'framework/html_behaviors/af-sort-column.scss';
@import 'framework/html_behaviors/af-autogrow.scss';
@import 'framework/html_behaviors/af-progress.scss';
@import 'framework/html_behaviors/af-mutex.scss';

@import 'framework/style_components/sc-fhsc.scss';
@import 'framework/style_components/sc-ersl.scss';
@import 'framework/style_components/sc-table.scss';
@import 'framework/style_components/sc-line-clamp.scss';

/* Common statuses configuration */

@import "styles/common-statuses.scss";

/* Components configuration */

@import "styles/application-menu.scss";
@import "styles/map-shared-components.scss";

/* Screen specific configuration */

@import "screens/administration/mobile-app-dashboard.scss";
@import "screens/administration/locations/locations.scss";

/* Browser configuration */

html, body {
  height: 100%;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #eceff1;
}

::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

/* Styles integration */

.fp.fa-fw {
  width: $fa-fw-width;
}

/* Dialog window theming */

ux-dialog-container > div > div {
  min-width: 256px;
}

ux-dialog {
  min-width: 256px;

  @include media-breakpoint-up(md) {
    max-width: 60vw;
  }

  @include media-breakpoint-down(sm) {
    max-width: 75vw;
  }

  @include media-breakpoint-down(xs) {
    max-width: 85vw;
  }

  ux-dialog-header {
    font-weight: bold;
  }

  ux-dialog-footer {
    padding: 4px 16px 4px 16px;
  }

  &.--success ux-dialog-body {
    @extend .bg-success, .text-white;
  }

  &.--danger ux-dialog-body {
    @extend .bg-danger, .text-white;
  }

  &.--warning ux-dialog-body {
    @extend .bg-warning, .text-dark;
  }

  &.--info ux-dialog-body {
    @extend .bg-info, .text-white;
  }

  ux-dialog-body {
    max-height: 70vh;
    max-width: 85vw;
    overflow: auto;
  }
}

.af-dialog__icon i.fas,
.af-dialog__icon i.far {
  @extend .fa-2x, .fa-fw;
  color: inherit;
}

/* Json formatter colors */

.json-key {
  color: brown;
}

.json-string {
  color: olive;
}

.json-number {
  color: navy;
}

.json-boolean {
  color: teal;
}

.json-null {
  color: dimgray;
}

a.json-link {
  color: purple;
  transition: all 400ms;
}

a.json-link:visited {
  color: slategray;
}

a.json-link:hover {
  color: blueviolet;
}

a.json-link:active {
  color: slategray;
}

/* Bootstrap adjustments */

.btn, .nav-item {
  white-space: nowrap;
}

.btn-toolbar {
  .btn-link {
    padding: 4px 8px;
    margin-top: 2px;
  }
}

.nav-tabs {
  .btn-toolbar {
    .btn-link {
      margin-top: 0px;
      margin-bottom: 2px;
    }
  }
}

.jumbotron {
  @include media-breakpoint-up(sm) {
    padding: $jumbotron-padding $jumbotron-padding;
  }
}
/* Navigation core styles */

.nav-heading {
  @extend .nav-link;
  font-weight: $headings-font-weight;
  text-transform: uppercase;

  &:hover {
    border-color: transparent !important;
  }
}
/* Tables theming */

.table th {
  color: $table-head-color;
  background-color: $table-head-bg;
}
/* Navigation theming */

.nav-item i.fas, .nav-item i.far {
  @extend .fa-fw;
}

.nav.flex-column .nav-item i {
  @extend .mr-1;
}

/* Menu color overrides */

.nav-tabs {
  .nav-heading i {
    @extend .mr-1;
    color: $client-dark;
  }

  .nav-item.active {
    margin-bottom: -2px;

    .nav-link {
      margin-top: -1px;
      border-top: 2px solid $client-light;
    }
  }
}

.nav.--reloading .nav-heading i {
  @extend .fa-spinner, .fa-spin;
}
/* Input controls theming */

.form-control {
  background: transparent;
  border-color: transparent;
  border-bottom-color: $input-focus-border-color;
}

.form-control:disabled {
  background: transparent;
  border-bottom-color: $input-border-color;
}

.form-control:hover:enabled {
  background: $input-focus-bg;
}

select:enabled {
  padding-left: 8px;
}

select:disabled {
  -webkit-appearance: none;
  -moz-appearance: none;
}

input:disabled::placeholder,
textarea:disabled::placeholder,
input[type=date].af-valuable--emptyvalue:disabled::-webkit-datetime-edit,
.af-plhrable--placeholder:disabled {
  color: transparent;
}

.form-control-plaintext {
  font-weight: $input-font-weight;
}
/* Control like layout */

.form-content {
  display: block;
  width: 100%;
  padding: $input-padding-y $input-padding-x;
  margin-bottom: 0;
  @include font-size($input-font-size);
  line-height: $input-line-height;
  border: $input-border-width solid transparent;
  border-bottom-color: $input-focus-border-color;

  &.--truncate {
    @extend .text-truncate;
  }

  &.--disabled {
    border-bottom-color: $input-border-color;
  }

  &.--noborder {
    border-color: transparent !important;
  }

  &.--nopadding {
    padding: $input-padding-y 0;
  }
}
/* Form group theming */

.form-group > small {
  @extend .form-text;
  padding-left: 13px;
  padding-right: 13px;
  color: $text-muted;
}
/* Validation theming */

.form-group.is-invalid > .form-label {
  display: none !important;
}

.form-group.is-invalid > .form-feedback {
  color: $danger;
}

.form-group.is-invalid .form-control {
  border-bottom-color: $danger;
}
/* Autocomplete adjustments */

.af-autocomplete {
  .__line-second.--size-small {
    padding-bottom: 1px;
  }

  .__line-second small {
    color: darkgray;
  }

  li.--selected .__line-second small {
    color: $autocomplete-item-selected-color;
  }
}
/* Toast notifications core */

.bs-toast-item {
  @extend .toast, .my-2;

  &__header {
    @extend .toast-header;

    > i, > strong {
      @extend .mr-2;
    }

    > button {
      @extend .ml-auto, .mb-1, .close;
    }
  }

  &__body {
    @extend .toast-body;
  }
}
/* Toast messages theming */

.bs-toast-item {
  &__header {
    @extend .mb-n1;
    background-color: transparent;
    border-bottom: 0;
  }

  &__header > i {
    @extend .fa-lg;
  }

  &.--success {
    background-color: #b3e6b3;
  }

  &.--success &__header {
    color: darken($success, 10%);
  }

  &.--warning {
    background-color: #ffd48f;
  }

  &.--warning &__header {
    color: darken($solid-orange, 10%);
  }

  &.--danger {
    background-color: #e6b3b3;
  }

  &.--danger &__header {
    color: darken($danger, 10%);
  }
}

/* bs-form-lookup loader styles */
.bs-form-lookup-container {
  position: relative;
}

.bs-form-lookup-icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}

/* Custom button variants */

.btn-icon {
  @extend .btn-light;
  @include button-variant(#eceff1, transparent);
  padding-left: 8px;
  padding-right: 8px;

  i.fas, i.far {
    width: $fa-fw-width;
  }

  &.btn-sm {
    padding: 2px 4px 2px 4px;
    border-radius: 0;
  }
}
/* Shared layout utilities */

.sc-pre-line {
  white-space: pre-line;
}

.sc-buttons-container {
  padding-bottom: 4px;

  button {
    margin-top: 4px;
  }
}

.sc-filter-container {
  @extend .my-2;
}

.sc-list-highlight span.--highlight {
  background-color: $client-highlight;
}

.sc-content-main {
  font-weight: 600;
}

.sc-table-norows {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $table-accent-bg;
  margin-top: -$spacer;
  margin-bottom: $spacer;
  height: 180px;
}

.sc-row-even {
  background-color: $table-accent-bg !important;

  &.sc-row-highlighted {
    background-color: $client-highlight !important;
  }
}

.sc-row-highlighted {
  background-color: $client-highlight !important;
}

.sc-row-pair-1 td {
  padding-bottom: calc($table-cell-padding / 2);
}

.sc-row-pair-2 td {
  padding-top: calc($table-cell-padding / 2);
  font-size: small;
  color: gray;
}

.sc-selectable {
  cursor: pointer;
}

.sc-archived {
  @extend .text-muted;
  text-decoration: line-through;
}
/* Shared controls theming */

.as-page-header {
  @extend .d-flex, .align-items-center, .py-1;
  display: block;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
  background-color: $body-bg;
  border-bottom: 2px dotted #eceff1;
  outline: $input-focus-width solid $body-bg;

  &__heading {
    @extend .d-flex, .align-items-center, .text-truncate;
    min-height: 47px;

    h4 {
      @extend .my-0, .text-truncate;
      color: $primary;
      min-height: 30px;
    }

    button, h4 {
      @extend .mr-2;
    }
  }

  &__aside {
    @extend .ml-auto;
    text-align: right;
  }
}

.as-page-jumbo {
  @extend .d-flex, .jumbotron;

  &__icon {
    @extend .d-none, .d-sm-block, .mr-4;
  }

  &__main {
    @extend .w-100;
  }

  &__main > p {
    @extend .lead;
  }

  &__icon > span,
  &__main > h1 {
    @extend .display-4;
    font-size: 42px;
  }
}

.as-form-section {
  @extend .my-3;

  > h6 {
    font-weight: normal;
  }

  &__footer {
    @extend .mt-1, .px-4;
    text-align: center;
    background-color: #eceff1;
  }
}

.as-widget-list {
  &__item {
    @extend .d-flex, .p-2;
  }

  &__item:not(:first-child) {
    @extend .mt-1;
  }

  &__item-main {
    @extend .flex-grow-1;
  }

  &__item-controls {
    @extend .ml-2;
    text-align: right;
  }

  &__item-controls .__handler {
    height: 42px;
  }
}

.as-widget-stack {
  @extend .d-inline-flex, .flex-wrap;

  &__show-new-item-widget-button {
    @extend .mr-2, .mb-2;
  }

  &__item {
    @extend .d-flex, .p-2, .mr-2, .mb-2;
  }

  &__item-main {
    @extend .flex-grow-1;
  }

  &__item-controls {
    @extend .ml-2;
    text-align: right;
  }
}

.as-widget-item {
  @extend .p-2;
  padding-right: 44px !important;
}

.as-form-widget {
  @extend .p-2;

  &__main {
    @extend .d-flex;
  }

  &__icon {
    @extend .mr-2;

    span {
      @extend .form-control-plaintext;
    }
  }

  &__content {
    @extend .flex-grow-1;
  }
}

.as-items-loader {
  text-align: center;
  margin-bottom: $spacer;
}
/* Splash screen layout */

.sc-splash-content {
  visibility: visible !important;
}
/* Application frame layout */

.application-frame {
  @extend .d-flex, .flex-column, .h-100, .overflow-hidden;

  &__head {
    border-bottom: 2px solid $client-base;

    .--is-mobile-app & {
      display: none;
    }
  }

  &__body {
    @extend .d-flex, .flex-column, .flex-md-row, .w-100, .flex-grow-1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &__main {
    @extend .flex-grow-1;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

.application-bar {
  @extend .d-flex, .justify-content-between, .align-items-center;

  .__logo-big {
    @extend .d-none, .d-md-block, .mx-2, .mt-1, .mb-2;
  }

  .__logo-small {
    @extend .d-md-none, .ml-3, .mr-2;
  }

  .__toggle {
    @extend .d-md-none, .mr-3, .ml-2, .my-2;
  }
}

.application-alert {
  @extend .d-flex, .justify-content-center;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  @include media-breakpoint-down(md) {
    bottom: 8px;
  }

  @include media-breakpoint-up(lg) {
    top: 1px;
  }

  .bs-toast-list {
    @include media-breakpoint-up(sm) {
      width: 348px;
    }

    @include media-breakpoint-down(xs) {
      width: 310px;
    }
  }
}
/* Application form skeleton */

.as-skeleton div {
  height: 10px;
  animation: shimmer 3s 5;
  background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 35%);
  background-size: 1000px 100%;
}

.as-form-skeleton {
  @extend .my-4;

  div {
    margin-top: 10px;
    margin-bottom: 10px;
    pointer-events: none;
  }
}

.as-table-skeleton {
  @extend .sc-content-appear;

  td {
    height: 36px;
    vertical-align: middle;
    pointer-events: none;
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }

  100% {
    background-position: 1000px 0;
  }
}
/* Reusable animations library */

.sc-content-appear > * {
  animation: appear .75s;
}

@keyframes appear {
  0% {
    opacity: .2;
  }

  100% {
    opacity: 1;
  }
}

.sc-element-blink {
  animation: blink normal 1.5s infinite ease-in-out;
}

@keyframes blink {
  50% {
    opacity: .25;
  }
}

.sc-pulse-primary {
  animation: pulse-primary 1.5s infinite;
  box-shadow: 0 0 0 0 rgba($primary, 0.5);
}

@keyframes pulse-primary {
  0% {
    transform: scale(.95);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 15px rgba($primary, 0);
  }

  100% {
    transform: scale(.95);
    box-shadow: 0 0 0 0 rgba($primary, 0);
  }
}

.sc-pulse-warning {
  animation: pulse-warning 1.5s infinite;
  box-shadow: 0 0 0 0 rgba($warning, 0.5);
}

@keyframes pulse-warning {
  0% {
    transform: scale(.95);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 15px rgba($warning, 0);
  }

  100% {
    transform: scale(.95);
    box-shadow: 0 0 0 0 rgba($warning, 0);
  }
}

.sc-pulse-white {
  animation: pulse-white 1.5s infinite;
  box-shadow: 0 0 0 0 rgba(white, 0.5);
}

@keyframes pulse-white {
  0% {
    transform: scale(.95);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 15px rgba(white, 0);
  }

  100% {
    transform: scale(.95);
    box-shadow: 0 0 0 0 rgba(white, 0);
  }
}

.sc-spin {
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  to {transform: rotate(360deg); }
}
/* Widget color overrides */

.as-widget-list__item.li-country-contact,
.as-widget-list__item.li-corporate-traveler,
.as-widget-list__item.li-contractor-traveler,
.as-widget-list__item.li-holiday-maker,
.as-widget-list__item.li-country-request,
.as-widget-item.si-business-details,
.as-widget-stack__item.li-admin-country-email,
.as-widget-stack__item.li-admin-user-selector,
.as-widget-stack__item.li-admin-user-contact-selector,
.as-widget-stack__item.li-admin-country-selector,
.as-widget-list__item.li-accommodation-type-panel,
.as-widget-list__item.li-approval-level-panel,
.as-widget-list__item.li-transportation-type-panel,
.as-widget-list__item.li-travel-type-panel,
.as-widget-list__item.li-deviation-team-region-director-panel,
.as-widget-item.deviation-request-info-panel {
  background-color: $light-gray;
}

.as-widget-list__item.li-city-segment,
.as-widget-item.wg-class-of-travel-deviation-detail {
  background-color: $light-aqua;
}

.as-widget-list__item.li-transport-segment,
.as-widget-item.wg-airline-extended-deviation-detail,
.as-widget-item.wg-airline-deviation-detail {
  background-color: $light-green;
}

.as-widget-list__item.li-accommodation-segment,
.as-widget-item.wg-hotel-deviation-detail {
  background-color: $light-orange;
}

.as-widget-list__item.li-note-segment {
  background-color: $light-red;
}

.as-widget-list__item.li-country-approver,
.as-widget-item.deviation-request-approvals {
  background-color: $light-yellow;
}
/* Widget layout overrides */

.wg-holiday-maker,
.wg-business-details {
  .as-widget-list__item {
    padding: 0 !important;
  }

  .as-widget-list__item:not(:first-child) {
    margin-top: 0 !important;
  }
}

.wg-country-visit,
.wg-country-request {
  &__message {
    font-weight: $input-font-weight;
  }

  &__message.--approval-required {
    color: red;
  }

  &__message.--approval-optional {
    color: green;
  }
}

.wg-country-approver__button-name {
  @extend .d-inline-block;
  width: 100px;
}
/* Component layout overrides */

.country-visits-panel {
  @extend .mx-n2;

  .as-widget-list__item {
    padding: 0 !important;
  }

  .as-widget-list__item:not(:first-child) {
    margin-top: 0 !important;
  }

  .as-form-widget__icon i {
    color: white;
  }

  .form-control {
    border-bottom-color: $input-placeholder-color;
  }
}

.country-experiences-panel {
  table {
    @extend .mb-1;
  }

  td:first-child {
    padding-left: 0;
  }

  td:last-child {
    padding-right: 0;
  }

  table label {
    margin-bottom: 0;
  }

  .is-invalid &__radio {
    color: $danger;
  }

  i {
    @extend .mr-1;
  }
}

.country-approval-panel {
  &__status-box {
    background-color: white;
  }

  &__status-table {
    padding: 0 12px;
  }

  &__status-table .form-row {
    @extend .pb-2;
  }

  &__status-table .__comment {
    @extend .font-italic, .text-muted;
  }
}

.deviation-request-create-selector {
  position: relative;
  width: 380px;
  margin-top: 5px;
  margin-bottom: 5px;

  &.--single-instance {
    background-color: white;
    color: black;
  }

  &.--entity-wide {
    background-color: white;
    color: black;
  }

  &.--disabled {
    background-color: lightgray !important;

    .deviation-request-create-selector__description {
      font-style: italic;
    }
  }

  &__box {
    padding: 20px;
    cursor: pointer;
  }

  &__icon {
    padding-top: 2px;
  }

  &__text {
    margin-left: 10px;
    margin-right: 10px;
  }

  &__chevron {
    @extend .ml-auto;
    padding-top: 2px;
  }
}

.deviation-request-create-options {
  width: 380px;
  margin-top: -5px;

  ul {
    position: absolute;
    background-color: white;
    color: black;
    z-index: 1000;
    list-style-type: none;
    padding: 7px 0 7px 0;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px 0px;
    cursor: pointer;

    li {
      padding: 6px 15px 6px 15px;

      span {
        display: inline-block;

        i.item-icon {
          margin-right: 10px;
        }
      }

      span.info-icon {
        margin: 0 10px;
        float: right;

        i {
          color: $solid-blue;
        }
      }
    }

    li:hover {
      background-color: lightgrey;
    }
  }
}

@include media-breakpoint-down(lg) {
  .deviation-request-create-selector {
    width: 305px;
  }
}

@include media-breakpoint-down(md) {
  .deviation-request-create-selector {
    width: 380px;
  }
}

@include media-breakpoint-down(xs) {
  .deviation-request-create-selector {
    width: unset;
  }
}

.deviation-request-assign-to-button {
  display: inline;

  button {
    position: relative;
  }

  ul {
    position: absolute;
    background-color: white;
    color: black;
    z-index: 1000;
    list-style-type: none;
    text-align: left;
    padding: 7px 0 7px 0;
    box-shadow: rgba(0,0, 0, 0.4) 0px 0px 5px 0px;
    cursor: pointer;

    li {
      padding: 6px 15px 6px 15px;
    }

    li:hover {
      background-color: lightgrey;
    }
  }
}
/* Screen specific overrides */

.home-welcome-screen {
  min-height: calc(100% - 24px);
  min-height: -moz-calc(100% - 24px);
  min-height: -webkit-calc(100% - 24px);
}

.home-welcome-screen__card {
  background-color: $light-gray;

  &.--requests {
    background-color: $light-orange;
  }

  &.--countries {
    background-color: $light-aqua;
  }

  &.--deviation-requests {
    background-color: $light-green;
  }

  &.--airlines {
    background-color: $light-gray;
  }

  &.--website {
    background-color: $light-red;
  }

  &.--contacts {
    background-color: $light-yellow;
  }
}

.home-welcome-screen__card,
.contacts-info-screen__card {
  @extend .card, .text-center;
  height: 100%;
}

.travel-requests-list-screen .as-page-jumbo {
  background-color: $solid-orange;
  color: white;
}

.holiday-trips-list-screen .as-page-jumbo {
  background-color: $solid-blue;
  color: white;
}

.deviation-requests-list-screen .as-page-jumbo {
  background-color: $solid-green;
  color: white;

  .additional-intro p {
    a {
      color: white;
    }

    a:hover {
      color: lightgray;
    }
  }
}

.countries-list-screen__card {
  @extend .card;
  height: 280px;

  @include media-breakpoint-up(xl) {
    height: 360px;
  }

  @include media-breakpoint-up(lg) {
    height: 320px;
  }

  @include media-breakpoint-down(xs) {
    height: 350px;
  }

  &.--approval-required {
    background-color: $light-orange;
  }

  h5.text-truncate {
    min-height: 25px;
  }
}

.admin-roles-screen, .admin-questions-screen {
  h5 .--highlight {
    background-color: $client-highlight;
  }
}
/* Business state colors & icons */
.at-approval-status, .ai-approval-status {
  &.--pending {
    color: $state-orange;
  }

  &.--approved {
    color: $state-green;
  }

  &.--declined {
    color: $state-red;
  }

  &.--requiremoreinfo {
    color: $state-blue;
  }
}

.ab-approval-status, .ai-approval-status {
  &.--pending {
    @extend .far, .fa-clock;
  }

  &.--approved {
    @extend .far, .fa-check-circle;
  }

  &.--declined {
    @extend .fas, .fa-times-circle;
  }

  &.--requiremoreinfo {
    @extend .fas, .fa-question-circle;
  }
}

.at-deviation-request-status, .ai-deviation-request-status {
  &.--pending {
    color: $state-orange;
  }

  &.--supportedbyregiondirector {
    color: $state-orange;
  }

  &.--supported {
    color: $state-green;
  }

  &.--rejected {
    color: $state-red;
  }

  &.--expired {
    color: $state-gray;
  }
}

.ab-deviation-request-status, .ai-deviation-request-status {
  &.--pending {
    @extend .far, .fa-clock;
  }

  &.--supportedbyregiondirector {
    @extend .far, .fa-clock;
  }

  &.--supported {
    @extend .far, .fa-check-circle;
  }

  &.--rejected {
    @extend .fas, .fa-times-circle;
  }

  &.--expired {
    @extend .fas, .fa-minus-circle;
  }
}
/* Template specific styles */

.ai-airline-status {
  &.--status-1 {
    color: $state-green;
    @extend .fa-asterisk;
  }

  &.--status-2 {
    color: $state-orange;
    @extend .fa-check;
  }

  &.--status-3 {
    color: $state-red;
    @extend .fa-times;
  }
}

.ai-country-approve-type {
  &.--type-1 {
    @extend .fa-user;
  }

  &.--type-2 {
    @extend .fa-users;
  }

  &.--type-3 {
    @extend .fa-user-friends;
  }
}

.ai-country-approval-requirement {
  &.--requirement-1 {
    color: $state-green;
    @extend .fa-thumbs-up;
  }

  &.--requirement-2 {
    color: $state-red;
    @extend .fa-exclamation-circle;
  }

  &.--requirement-3 {
    color: $state-orange;
    @extend .fa-plane;
  }
}
